import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeAndSlideUp } from '@smartera/animations';
import { BaseComponent } from '@modules/components/base-component';
import { AuthenticationUrls } from '../models';
import { UtilityService } from '@core/services/utility.service';

declare let swal;

@Component({
	selector: 'app-expire-password',
	templateUrl: './expire-password.component.html',
	styleUrls: ['./expire-password.component.scss'],
	animations: [fadeAndSlideUp],
	standalone: false,
})
export class ExpirePasswordComponent extends BaseComponent implements OnInit {
	public form: FormGroup;
	private expirePath: string = AuthenticationUrls.ExpiredPassword;

	constructor(
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		public _http: HttpClient,
		utilServ: UtilityService
	) {
		super(null, utilServ);
		this.form = new FormGroup(
			{
				oldPassword: new FormControl('', [Validators.required]),
				newPassword: new FormControl('', [Validators.required]),
				confirmPassword: new FormControl('', [Validators.required]),
			},
			passwordMatchValidator
		);

		function passwordMatchValidator(g: FormGroup) {
			return g.get('newPassword').value === g.get('confirmPassword').value ? null : { mismatch: true };
		}
	}

	public ngOnInit() {
		this._activatedRoute.params.subscribe(() => {
			this.hideloader();
		});
	}
	public renew(value: any): void {
		const currentEmail: string = this._activatedRoute.snapshot.params.email.toString().toLowerCase();

		this._http
			.post(this.expirePath, {
				email: currentEmail,
				oldPassword: value.oldPassword,
				newPassword: value.newPassword,
				newPasswordConfirm: value.confirmPassword,
			})
			.subscribe((data) => {
				this.utilServ.alertService.success(
					this.t('confirmation.success-message.title.password-forgot'),
					this.t('confirmation.success-message.message.password-register')
				);
				this._router.navigateByUrl('/login');
			});
	}
}
